import React, { FC } from 'react';
import styled from 'styled-components';
import { Accordion, Typography } from '@beeline.com/bp-design-system';
import { PageContent } from '../../common/SettingsPageElements';
import { JobProfilesTable } from './jobProfiles/JobProfilesTable';
import { JobFamilyTable } from './jobFamilies/jobFamilyTable';
import { JobFamilyGroupsTable } from './jobFamilyGroups/jobFamilyGroupsTable';
import { useJobCataloguesIntl } from './translations/useJobCataloguesIntl';
export const JobCatalogues: FC<React.PropsWithChildren<unknown>> = () => {
  const intl = useJobCataloguesIntl();

  const sections = [
    { dataTest: 'job-profiles-panel', title: intl.jobProfiles, Component: JobProfilesTable },
    { dataTest: 'job-families-panel', title: intl.jobFamilies, Component: JobFamilyTable },
    { dataTest: 'job-families-group-panel', title: intl.jobFamilyGroups, Component: JobFamilyGroupsTable }
  ];

  return (
    <StyledPageContent data-test="job-catalogues__page__container">
      {sections.map(({ dataTest, title, Component }) => (
        <StyledExpansionWrapper key={dataTest}>
          <Accordion dataTest={dataTest} variant="outlined">
            <StyledAccordionSummary>
              <StyledTitle variant="h4">{title}</StyledTitle>
            </StyledAccordionSummary>
            <Accordion.Details>
              <Component />
            </Accordion.Details>
          </Accordion>
        </StyledExpansionWrapper>
      ))}
    </StyledPageContent>
  );
};
const StyledPageContent = styled(PageContent)`
  overflow: scroll;
  padding-right: 0.25rem;
`;
const StyledExpansionWrapper = styled.div`
  margin: 1rem 0;
`;
const StyledTitle = styled(Typography)`
  padding: 1rem 0;
`;

const StyledAccordionSummary = styled(Accordion.Summary)`
 && { 
      padding: 0 1rem;
    }
  `;
